import { BRIDGE_NAME } from "../bridgeConstants";

export const listenForParentPostMessages = () => {
  window.addEventListener("message", message => {
    const { err, data, funcName, body } = message.data;

    if (funcName === "callbackHandler") {
      window[BRIDGE_NAME](err, undefined, data, body);
    }
  });
};
export const postMessage = data => {
  window.parent.postMessage(data, "*");
};
export const updateParentUrl = iframeURL => {
  postMessage({
    funcName: "updateUrl",
    data: iframeURL,
  });
};

export const webBridge = () => {
  listenForParentPostMessages();

  window.NativeStore = {
    getString(data) {
      postMessage({ funcName: "getString", data });
    },
    setString(tokenName, token) {
      postMessage({
        funcName: "setString",
        data: {
          tokenName,
          token,
        },
      });
    },
    getAppInfo(context, body) {
      postMessage({
        funcName: "getAppInfo",
        data: { context, body },
      });
    },
  };

  window.Freshbot = {
    getToken(context, body) {
      postMessage({
        funcName: "getToken",
        data: { context, body },
      });
    },
    logEvent(name, category, data) {
      postMessage({
        funcName: "logEvent",
        data: {
          name,
          category,
          data,
        },
      });
    },
    onBackPressed() {
      console.log("To be called from mobile");
    },
    //TODO: Remove exitWebview when the adoption is 100%
    exitWebview() {
      console.log("To be called from mobile");
    },
  };
};
